//白俄罗斯
export default {
    line: "лінія",
    language: "мова",
    common: [
      "Інтэрнэт-сэрвісы",
      "Адмяніць прыпыненне",
      "Ці варта марнаваць 10 000 USDT на пакупку!"
    ],
    informationHub: "Афіцыйны хаб SGM.s",
    upload: [
      "Загрузка...",
      "Няправільны фармат",
      "Паспяхова запампавана",
      "Памылка загрузкі"
    ],
    vanPull: [
      "Няма больш дадзеных",
      "Даных няма"
    ],
    login: {
      title:'Увайдзіце з дапамогай імя карыстальніка і пароля',
      title_txt:'Увайдзіце, выкарыстоўваючы зарэгістраваны нумар мабільнага тэлефона',
      text: [
        "Запомніце імя карыстальніка/пароль",
        "Запіс...",
        "Увайдзіце зараз"
      ],
      placeholder: [
        "Калі ласка, увядзіце нумар тэлефона",
        "Калі ласка, увядзіце пароль для ўваходу"
      ],
      i18n: [
        "Няма ўліковага запісу {title}? {a} {line}",
        "Зарэгіструйцеся"
      ]
    },
    register: {
      text: [
        "Запрашаем да рэгістрацыі",
        "Адпраўка SMS-кода...",
        "Атрымаць SMS код пацверджання",
        "Ідзе рэгістрацыя...",
        "Рэгістрацыя",
        "Ёсць уліковы запіс, спампаваць зараз",
        "Рэгістрацыя нумара мабільнага тэлефона",
        "Рэгістрацыя па электроннай пошце",
        "Вярнуцца да ўваходу",
        "Калі ласка, выкарыстоўвайце незарэгістраваны нумар тэлефона і адрас электроннай пошты"
      ],
      placeholder: [
        "Калі ласка, увядзіце свой нумар тэлефона",
        "Калі ласка, увядзіце код пацверджання SMS",
        "Калі ласка, увядзіце пароль для ўваходу",
        "Калі ласка, пацвердзіце пароль",
        "Калі ласка, увядзіце код запрашэння",
        "Два паролі розныя",
        "Калі ласка, увядзіце праверачны код",
        "Калі ласка, увядзіце нумар электроннай пошты",
        "Нельга пачынаць з 0"
      ],
      i18n: [
        "Ёсць уліковы запіс? {a} {line}",
        "Уваход"
      ]
    },
    home: {
      lucky:"Мерапрыемства яшчэ не адкрыта",
      map: "Размяшчэнне",
      qywh: "Карпаратыўная культура",
      broadcast: "Віншуем нашага партнёра: {member} рэкамендаваў {vipname} далучыцца і атрымаў {grade} {currency} бонус за прасоўванне!",
      menu: [
        "VIP зона",
        "Відэаўрок",
        "Узнагароды за прасоўванне"
      ],
      taskHall: {
        title: [
            "Зала задач",
            "Бізнэс Хол",
            "Выконвайце заданні, каб зарабіць прыбытак"
        ]
      },
      memberList: {
        title: "Спіс сяброўства",
        data: [
          "{member}, выканайце сённяшнія {num} заданняў па парадку!"
        ]
      },
      noticeTitle: ["Заўвага", "Папярэдняя", "Наступная"],
      tabBar: ["Дом", "Каманда", "T", "Карта", "Мой"],
      msg: "Задача не адкрытая",
      video: "Няма відэаўрока",
        message: "У вас новыя навіны",
        bonus:[
          '<p>Enter the password to receive the red envelope cash reward.</p><p>1. The password is obtained through company activities!</p><p>2. The working group issues passwords from time to time! You can pay attention to the working group information on a daily basis!</p><p>For details, please consult the "Recruitment Manager"</p>',
          'The password is obtained through company activities!',
          'Enter the red Envelope code',
          'Receive Red Envelope',
          'Congratulations on getting the red envelope bonus {amount}'
      ],
      helpCenter: {
        title: "Help Center",
        empty: "No help articles"
      }
    },
    vip: {
      title:[
        "VIP ўзровень",
        "Далучайцеся да сяброўства зараз, каб атрымаць заданні"
      ],
      user: {
        title: [
          "Ваша асоба",
            "Наведвальнікі"
        ],
        label: "Штодзённыя заданні",
        value: [
            "Дата ўступлення ў сілу",
            "Адзін год",
            "Калі ласка, увайдзіце спачатку",
            "Тэрмін дзеяння інтэрнатуры",
            "Зваротны адлік вяртання дэпазіту",
            "Зваротны адлік тэрміну дзеяння ўзроўню LP"
        ],
      },
      list: {
        label: "Штодзённыя заданні:{number}",
        button: "Далучайцеся заразJoin now",
        text: [
            "Штодзённы прыбытак",
            "Штомесячны даход",
            "Узнагарода пры найме: усе",
            "Бясплатны",
            "На заказ",
            "Рэйтынг-даход",
            "Эфектыўная аддача",
            "Тэрмін прыдатнасці",
            "Год",
            "Дзень",
            "Тэрмін дзеяння"
        ],
      },
      dialog: [
        "Вы ўпэўнены, што выдаткуеце {currency} {amount}, каб стаць {name}?",
        "Вы зараз {currname} і не можаце быць {name}",
        "Вы ўпэўнены, што выдаткуеце {currency} {amount} на падаўжэнне {name}?",
      ],
      index: ["Адмяніць", "Пацвердзіць"],
      desc: [
        '{level} Перавагі',
        "Базавы даход",
        "Час",
        "Колькасць заданняў",
        "Даход",
        "Штодня",
        "Штомесяц",
        "Штогод",
        "Рэкуітэтныя даходы", //8
        "Падпарадкаваны ўзровень",
        "Каэфіцыент камісіі па найму",
        "Бонус пры найме",
        "Падпарадкаваны ўзроўню 1",
        "Падначалены 2-га ўзроўню",
        "Падначалены 3-га ўзроўню",
        "Зніжка за адзін дзень",
        "Падпарадкаваны ўзровень",
        "Каэфіцыент скідкі падначаленага задання", //17
        "Сума скідкі задання",
        "Падпарадкаваны ўзроўню 1",
        "Падпарадкаваны ўзроўню 2",
        "Падпарадкаваны 3-га ўзроўню",
        "3 дні",
        "Цана за адзінку задачы",
        "Падрабязнасці выпрабавальнага тэрміну", //24
        "Стажыроўка: купля не патрабуецца, ёсць 2 заданні ў дзень, камісія за кожнае заданне складае 0,9 USDT, 1,8 USDT у дзень. Тэрмін стажыроўкі для стажораў складае ўсяго 2 дні",
        "Прыклад камісіі па заданню:",
        "<p>Падначаленыя 1-га ўзроўню выконваюць у агульнай складанасці 10 000 рупій у дзень, вы можаце атрымаць камісію за заданне ў памеры 300 рупій</p><p>Падначаленыя 2-га ўзроўню выконваюць агулам 10 000 рупій у дзень, вы можаце атрымаць камісію за заданне ў памеры 200 рупій</p><p>Падначаленыя 3-га ўзроўню выконваюць у агульнай складанасці 10 000 USDT заказаў у дзень, вы можаце атрымаць камісію за 100 USDT</p>",
        "Апісанне рэферальнага бонуса:",
        "<p>(Падначалены 1-га ўзроўню) Вы непасрэдна запрашаеце A далучыцца, A з'яўляецца вашым падначаленым 1-га ўзроўню.</p><p>(Падначалены 2-га ўзроўню) A запрашае B далучыцца, B з'яўляецца вашым падначаленым 2-га ўзроўню.</p><p>(Падначалены 3-га ўзроўню) B запрашае C далучыцца, C з'яўляецца вашым падначаленым 3-га ўзроўню.</p><p>Заўвага: бонус за рэфералы можа можна патрабаваць толькі за самы высокі бонус бягучага ўзроўню асобы.</p>",
      ]
    },
    charitable: [
      'ГЛАБАЛЬНАЯ ПЛАТФОРМА SGM',
      'Паглыбленне трансфармацыі лічбавага маркетынгу, садзейніча ў выкананні заканадаўства ў Цэнтральнай Азіі і будаўніцтва фінансавай свабоды разам з высокаякаснай камандай.',
      'Лічбавая эканоміка гіга і глабальная матрыца краўдсорсінгу ўступаюць у эпоху структурных дывідэндаў. На развіваючыхся рынках, асабліва ў Цэнтральнай Азіі (з Таджыкістанам у якасці асноўнага рэгіёна), існуе ўзрыўны попыт з боку вялікай працаздольнага насельніцтва на дыверсіфікаваную анлайн-занятасць з мінімальнымі бар\'ерамі для ўваходу і высокай даходнасцю.',
      'Дзякуючы ўнікальным тэхналогіям «Аднаўленне каштоўнасці асабістай сеткі» і «Размеркаванне лічбавых задач» мы ператвараем вольны час кожнага чалавека ў стабільныя эканамічныя актывы і дапамагаем дзясяткам тысяч сем\'яў дасягаць комплексных паляпшэнняў у ўмовах жыцця.',
      'Мы заклікаем вас актыўна ўдзельнічаць у грамадскіх дабрачынных ініцыятывах і разам дазволіць любові і зялёнаму квітнець у кожным кутку горада..',
      'Афіцыйны бізнес white paper v2.7.1'
    ],
    lucky: {
        default:[
            "Шчаслівы розыгрыш",
            "Астатняя колькасць розыгрышаў:",
            "Рэкорд розыгрышу",
            "Правілы латарэі",
            "<p>Удзельнічайце ў дзейнасці кампаніі і атрымлівайце магчымасці розыгрышу!</p>",
            "Запіс карыстальнікаў",
            ['Віншуем:{member}','Атрымайце прызы {profit}'],
            "Віншуем, атрымліваем прызы",
            "блізка",
            "Час вашага розыгрышу быў выкарыстаны",
            "Дзейнічае да"
        ],
      scattered:[
        "Колькасць розыгрышаў",
        "СТАРТ",
        '<p>1.Колькасць розыгрышаў атрымліваецца дзякуючы дзейнасці кампаніі!</p><p>2.Кожны розыгрыш займае 1 розыгрыш!</p><p>3.Пасля выйгрышу фізічнага прыза, калі ласка, звяжыцеся з менеджэрам па падборы персаналу, каб зарэгістраваць вашу інфармацыю і атрымаць яе!</p>',
        "Напамін",
      ],
    },
    userLc:{
        default:[
            "Павелічэнне багацця",
            "Запісы",
            "Сума",
            "Тэрмін захоўвання",
            "Сума дэпазіту",
            "Калі ласка, увядзіце суму дэпазіту",
            "Даход",
            "Адправіць", //7
            "Калі ласка, спачатку абярыце прадукт",
            "Калі ласка, абярыце інфармацыю",
            "Прыбытак",
            "Дзень",
            "Даных няма",
            "Час пакупкі",
            "дзяржава",
            "Канец часу",
            "Баланс",
            "Сённяшні заробак",
            "Купля ў адзін клік"//18
        ],
      tabs: [
        "Спіс тавараў",
        "Спіс укладзеных сродкаў"
       ],
      tips:'<p>VOISP "Wealth Enhance" - гэта спосаб кампаніі даць усім супрацоўнікам М-ўзроўню больш спосабаў павялічыць свой даход. Інвестыцыйныя праекты - гэта фінансавыя інвестыцыйныя праекты, запушчаныя сумесна PAGE, банкамі, кампаніямі па кіраванні актывамі і г.д.!</p><p>Кароткатэрміновыя інвестыцыі: стабільны прыбытак, гнуткі выбар цыклу! Кароткатэрміновыя бяздзейныя сродкі могуць прынесці дадатковы прыбытак праз інвестыцыі! Доўгатэрміновыя інвестыцыі: больш высокая прыбытковасць, развівайце добрыя рэгулярныя інвестыцыйныя зберажэнні, атрымлівайце больш высокую прыбытковасць і рэалізуйце свае мары праз назапашванне!</p>'
    },
    newlist: {
      text: [
        "Няма запісаў",
        "Чаканы даход",
        "вынікі",
        "выйграць час",
        "статус",
        "Канец часу"
      ],
      placeholder: [
       "больш няма дадзеных",
        "Даных няма"
      ],
      i18n: [
        "Гісторыя пакупак",
      ]
    },
    product: {
      default: [
        "Баланс акцыйнага рахунку",
 "Пачатковая сума інвестыцый",
 "Максімальная сума інвестыцый",
 "Цыкл",
 "Дзённая працэнтная стаўка",
 "максімум",
 "Правілы праекта",
 "Сума праекта",
 "Спосаб аплаты",
 "Пачатковая сума інвестыцый",
 "Штодзённы прыбытак",
 "Цыкл выпуску",
 "Прыблізны даход"
      ],
      investRange: "Дыяпазон сумы інвестыцый",
      placeholder: [
        "Вяртанне асноўнай сумы і даход па заканчэнні тэрміну (звычайна ў святочныя дні)",
        ", аўтаматычны разлік на працягу 24 гадзін",
        "{str} = агульны даход {income} {currency} + асноўная сума {money} {currency} = агульная асноўная сума і працэнты {total} {currency}",
        "Пароль бяспекі"
      ]
    },
    user: {
      vipl:"Партнёрскі ўзровень",
      hello:"Сардэчна запрашаем назад",
      default: [
        "Мой начальнік",
        "Рахунак",
        "Код запрашэння",
        "Выйсці з уваходу",
        "Баланс",
        "Золата",
        "Мой кашалёк",
        "Пячатка",
        "Абмежаванне",
        "Добра",
        "Выдатна",
        "Актываваць 'Памочнік па чытанні'",
        "Звязацца з менеджарам па найму"
      ],
      myEarnings: {
              grid: ["Баланс", "Учорашні заробак", "Сённяшні заробак", "Заробак за гэты тыдзень", "Заробак за гэты месяц", "Заробак за мінулы месяц", "Агульны даход", "Выканайце заданне сёння (PCE)", "Сённяшнія заданні, якія засталіся (PCE)", "Сённяшняя камісія", "Зніжка за заданне", "Зніжка за рэкамендацыю"]
          },
      grid: [
        "Баланс",
        "Учорашні заробак",
        "Сённяшні заробак",
        "Прыбытак на гэтым тыдні",
        "Прыбытак гэтага месяца",
        "Прыбытак за мінулы месяц",
        "Агульны даход",
        "Выканайце заданне сёння (PCE)",
        "Астатнія задачы на ​​сёння (PCE)",
        "Сённяшняя камісія",
        "Сённяшняя зніжка"
      ],
      menu: [
        "Запісы заданняў",
        "Аўдытарскае заданне",
        "Кіраванне рэлізамі",
        "Асабістыя звесткі", //3
        "Прывязка акаўнта",
        "Штодзённая справаздача",
        "Бухгалтарскія запісы",//6
        "Запрасіць сяброў",
        "Зборныя справаздачы",//8
        "Дапаможнік", //9
        "Крэдытны рэйтынг", //10
        "Спампаваць APP",//11
        "Шчаслівы розыгрыш",//12
        "Інвестыцыйная зона",
        "Памочнік па чытанні",
        "Профіль кампаніі",
        "Відэападручнік",
        "Выдатная каманда",
        "Інвестыцыйная зона",
        "Ідзі за SGM.s",
        "Узнагароды росту",
        "Чырвоны канверт",
        "Дабрачыннасць",
        "Сертыфікат SGM"
      ],
      positions:[
        "Мая пазіцыя",
        "Бягучая пазіцыя",
        "Наступная пазіцыя",
        "Непасрэдна афіляваны член LP-level",
        "Удзельнік каманды LP 3-га ўзроўню",
        "Каманда 3-га ўзроўню (колькасць {пасад})",
        "Выканайце ўсе патрабаванні, каб звязацца з мэнэджарам па найму, каб павысіць сваю пазіцыю!",
        "Прафесійная характарыстыка",
      ],
      office:[
        "Інфармацыя аб маёй пазіцыі",
        "Падрабязнасці прасоўвання па службе",
        "Прафесійная інструкцыя SGM",
        "Пазіцыі кампаніі",
        "Прасоўванне па службе",
        "Адправіць заяўку",
        "Ход прасоўвання",
        "Прынамсі",
        "Умовы не выкананы",//8
        "члены трохузроўневай каманды (1/2/3) павінны стаць ({name}).",
        "Каманда павінна мець больш чым",
        "члены",
        "Атрымана"//12
      ],
      current:[
          "Бягучыя пазіцыі",
            "Усяго членаў LP"
      ],
      subordinate:[
          "А-ўзровень",
            "Узровень B",
            "C-узровень",
            "спіс удзельнікаў",
            "усяго людзей",
            "Агульны даход",
            "Сума зняцця",
            "Камандны даход",
            "Спіс удзельнікаў",
            "карыстальнік",
            "узровень",
            "Час далучэння",
            "Выпрабавальны тэрмін"
      ],
      follow:[
          "SGM.s Official Channel",
          "Follow the channel to learn more about the latest SGM.s information!"
      ]
    },
    userInfo: {
      default: [
        "Асабістая інфармацыя",
        "Партрэт галавы",
        "Мабільны нумар",
        "Дадаць банкаўскі рахунак",
        "Аліпэй",
        "Сапраўднае імя",
        "Пароль для ўваходу",
        "Пароль фонду",
        "Націсніце Налады",
        "Змяніць партрэт галавы",
        "Змяніць пароль для ўваходу",
        "Змяніць пароль фонду",
        "Адправіць",
        "Ачысціць кэш",
        "Выйсці"
      ],
      label: [
        "Зыходны пароль для ўваходу",
 "Новы пароль для ўваходу",
 "Пацвярджэнне пароляў",
 "Арыгінальны код грошай",
 "Новы грашовы код",
 "Пацвердзіць пароль"
      ],
      placeholder: [
        "Калі ласка, увядзіце зыходны пароль для ўваходу",
 "Калі ласка, увядзіце новы пароль для ўваходу",
 "Калі ласка, пацвердзіце пароль для ўваходу",
 "Калі ласка, увядзіце зыходны пароль фонду",
 "Калі ласка, увядзіце новы пароль сродкаў",
 "Калі ласка, пацвердзіце пароль фонду"
      ]
    },
    userSet: {
      default: [
        "Сертыфікацыя сапраўднага імя",
 "Падрабязная інфармацыя",
 "Прывязаць Alipay",
 "Адправіць"
      ],
      label: [
        "Сапраўднае імя",
 "QQ",
 "Рахунак Alipay",
 "Назва Alipay"
      ],
      placeholder: [
        "Калі ласка, увядзіце сапраўднае імя (Маё імя выкарыстоўваецца для зняцця наяўных)",
 "Увядзіце нумар QQ",
 "Калі ласка, увядзіце рахунак Alipay",
 "Калі ласка, увядзіце імя Alipay"
      ],
      tips: "Напамін: прывязаная банкаўская карта не можа быць зменена, яна выкарыстоўваецца для зняцця сродкаў"
    },
    bindAccount: {
      default: [
        "Прывязаць уліковы запіс",
 "Праглядзець падручнік",
 "Адправіць"
      ],
      tabs: [
        "Рахунак",
 "Рахунак",
 "Рахунак"
      ],
      label: [
        "Інструкцыя",
 "Дадаць скрыншот",
 "Рахунак"
      ],
      placeholder: "Калі ласка, увядзіце свой уліковы запіс {account}"
    },
    bankCard: {
      default: [
        "Прывязаць банкаўскую карту",
 "Аўтэнтыфікаваць зараз",
 "Адпраўка...",
 "Дадаць зараз",
 "Дадаць банкаўскую карту"
      ],
      tips: [
        "Перад даданнем банкаўскай карты прайдзіце аўтэнтыфікацыю па-сапраўднаму",
        "Імя рахунку на вашай банкаўскай карце павінна супадаць з сапраўдным імем, якое вы праверылі, інакш вы не зможаце паспяхова зняць наяўныя",
      ],
      label: [
        "Імя",
 "Назва банка",
 "Нумар банкаўскага рахунку",
 "Код філіяла"
      ],
      placeholder: [
        "Калі ласка, абярыце назву банка",
 "Калі ласка, увядзіце нумар банкаўскага рахунку",
 "Калі ласка, увядзіце код філіяла",
 "Пацвердзіць",
 "Адмяніць"	
      ]
    },
    wallet: {
      default: [
        "Мой кашалёк",
        "Папаўненне",
        "Зняцце",
        "Запіс папаўнення",
        "Запіс аб зняцці сродкаў",
        "Р",
        "W",
        "Папаўненне USDT"
      ],
      label: [
        "Спосаб вываду",
        "Сума зняцця",
        "Пароль фонду",
        "Адправіць",
        "Нумар тэлефона",
        "Электронная пошта",
        "IFSC",
        "Спосаб аплаты",
        "Падаткаабкладанне",
        "Фактычная сума атрымана"
      ],
      placeholder: [
        "Выбраць спосаб вываду",
 "Калі ласка, увядзіце суму зняцця",
 "Калі ласка, увядзіце пароль фонду",
 "Калі ласка, абярыце спосаб вываду",
 "Калі ласка, увядзіце нумар мабільнага тэлефона атрымальніка",
 "Калі ласка, увядзіце адрас электроннай пошты атрымальніка",
 "Калі ласка, увядзіце атрымальнік плацяжу IFSC",
 "Калі ласка, абярыце спосаб аплаты"
      ],
      msg: [
        "Вы яшчэ не ўсталявалі пароль фонду, спачатку ўсталюйце яго",
 "Вы яшчэ не прывязалі сваю банкаўскую картку, спачатку прывяжыце яе",
 "<p>Час вываду:</p><p>Панядзелак: M9</p><p>Аўторак: M8</p><p>Серада: M6/M7</p><p>Чацвер: M3/M4/M5</p><p>Пятніца: M1/M2</p><p>(Інтэрны з панядзелка па нядзелю)</p><p>9 раніцы да 6 вечара</p>"
      ]
    },
    recharge: {
      default: [
        "Папаўненне",
        "Падрабязнасці папаўнення",
        "Запіс папаўнення",
        "Даступны баланс {money}, абярыце спосаб папаўнення",
        "Адзіная мінімальная сума складае {currency} {min}, максімальная {currency} {max}, плата за апрацоўку {fee}%",
        "Адпраўка...",
        "Папоўніце зараз",
        "Вяртанне",
        "Загрузка...",
        "Адзіная мінімальная сума складае ${min}, максімальная ${max}, плата за апрацоўку {fee}%"
      ],
      label: [
        "Сума папаўнення",
        "Канал папаўнення",
        "Назва перадачы",
        "Імя плацельшчыка",
        "Мабільны тэлефон плацельшчыка",
        "Уліковы запіс плацельшчыка UPI",
        "Электронная пошта плацельшчыка",
        "Заказ на здзелку"
      ],
      placeholder: [
        "Калі ласка, увядзіце суму папаўнення",
        "Калі ласка, абярыце канал папаўнення",
        "Калі ласка, увядзіце назву пераводу",
        "Адзіная мінімальная сума складае {currency} {min}",
        "Адзіная максімальная сума складае {валюта} {макс}",
        "Калі ласка, увядзіце імя плацельшчыка",
        "Калі ласка, увядзіце нумар мабільнага тэлефона плацельшчыка",
        "Калі ласка, увядзіце рахунак UPI плацельшчыка",
        "Калі ласка, увядзіце адрас электроннай пошты плацельшчыка",
        "Калі ласка, загрузіце скрыншот перадачы",
        "Калі ласка, увядзіце нумар заказу транзакцыі"
      ],
      info: [
        "Сума папаўнення",
        "Нумар заказу",
        "Банк",
        "Нума рахунку",
        "Імя",
        "Капіяваць",
        "{type} Перадача",
        "Перадаць скрыншот",
        "Адправіць",
        "Кодэкс IFSC",
        "Тып рахунку",
        "Інструкцыя па апрацоўцы"
      ],
      tips: [
        "Калі ласка, выберыце наступны спосаб пералічэння адпаведнай сумы, каб пазбегнуць затрымкі фінансавай праверкі.<br>Пасля пераводу загрузіце скрыншот пераводу ў якасці пацверджання пацверджання",
        "Не трэба дадаваць сяброў, сканіруйце QR-код, каб перавесці мне грошы",
        "Калі ласка, завяршыце перадачу ў адпаведнасці з інфармацыяй ніжэй",
        "Падказка: пасля паспяховай аплаты, калі ласка, звяжыцеся з онлайн-службай, каб паведаміць нумар вашага рахунку ўдзельніка, суму папаўнення, нумар заказу, нумар рахунку ўкладчыка, час папаўнення, што зручна для фінансавага аддзела, каб своечасова папоўніць сродкі.",
        "Заўвага: калі ласка, адпраўце адзін плацёж за кожны перавод",
        "Пасля перадачы загрузіце скрыншот перадачы ў якасці сертыфіката праверкі",
        "Парада: пасля паспяховай аплаты загрузіце фатаграфію паспяховай транзакцыі",
        "<p>Напамін аб папаўненні:</p><p>Калі пасля адпраўкі заказа на папаўненне вы не можаце перайсці непасрэдна да праграмы Ccash/Maya, вы можаце выкарыстоўваць скрыншот, каб захаваць QR-код у альбом, і выкарыстаць QR-код, каб завяршыць плацёж!</p><p>(QR-код сапраўдны для аднаго плацяжу, і забаронена захоўваць QR-код для другога плацяжу)</p>"
      ],
      minPayHint: "Аз {min} TJS камтар папаўнення намудан мумкин нест"
    },
    task: {
      default: [
        "Спіс задач",
        "Патрабаванні да задання",
        "Стварыць",
        "Аўдыт",
        "Адкрыць спасылку",
        "Капіяваць спасылку",
        "Кошт за адзінку",
        "Адправіць",
        "Адмова",
        "Пачаць падачу",
        "У працэсе",
        "ПАЧАЦЬ ЗАДАННЕ"
      ],
      tabs: [
        "Рабіць",
        "Аўдыт",
        "Завершана",
        "Не атрымалася",
        "Зламыснасць",
        "Пакінуты"
      ],
      msg: "Сённяшняя місія выканана",
      msgSc: "Successfully receivedПаспяхова атрымана",
      msgTime: "Пасля заканчэння зваротнага адліку заданне будзе выканана аўтаматычна, і яго датэрміновае закрыццё будзе несапраўдным!",
      info: [
        "Падрабязнасці задання",
        "Назва задачы",
        "Перавагі задання",
        "Апісанне задачы",
        "Патрабаванні да загрузкі",
        "Адправіць узор",
        "Карыстальнік не адправіў узор",
        "Аўдытарскія запіскі",
        "Дата аўдыту",
        "Бок попыту",
        "Вызваленьне",
        "Капіяваць",
        "Скачок",
        "Крокі задачы",
        "Крок {індэкс}",
        "Аўдытарскі ўзор",
        "Няма аўдытарскай выбаркі",
        "Загрузка дадзеных...",
        "Адмовіцца ад задачы",
        "Адправіць выкананае заданне",
        "Апублікаваць кантэнт"
      ],
      index: [
        "Бягучы стан",
        "Ваш бягучы рэйтынг <i style=\"color:#1989fa\">{currVip}</i><br>можа прэтэндаваць толькі на бягучае заданне ўзроўню <i style=\"color:#1989fa\">{currVip}</i><br>вы хочаце далучыцца да ўзроўню <i style=\"color:#dd6161\">{vip}</i>",
        "Далучайцеся зараз",
        "Калі ласка, абярыце катэгорыю задач",
        "Адмена",
        "Астатнія",
        "Бясплатная дастаўка",
        "Заставайцеся на сувязі"
      ],
      list: [
        "Спіс задач",
        "Бок попыту",
        "Астатнія",
        "Запыт",
        "Атрыманне"
      ],
      show: [
        "Падрабязнасці задання",
        "Час пакупкі",
        "Стан дастаўкі",
        "Кошт арэнды",
        "Час дастаўкі",
        "Зваротны адлік да атрымання",
        "Пачаць абслугоўваць",
        "кадаваньне",
        "невядома"
      ]
    },
    postRecord: [
        "Кіраванне рэлізамі",
        "Вызваленьне",
        "Усяго",
        "Завершана",
        "Дэдлайн",
        "Аўдыт",
        "Скасаванне",
        "Рэдактары"
    ],
    dayReport: [
      "Штодзённая справаздача",
        "Агульны даход",
        "Мая камісія",
        "Мая камісія",
        "Заданні, выкананыя падначаленымі",
        "Выгоды падначаленага задання",
        "PCE",
        "Апошнія 30 дзён",
        "Колькасць",
        "Задача",
        "Падначалены",
        "Спажыванне",
        "Дата"
    ],
    fundRecord: {
      default: [
        "Расходныя запісы",
        "Запіс папаўнення",
        "Даходы",
        "Р",
        "я",
        "Е",
        "Запісы аб зняцці сродкаў",
    ],
      tabs: [
        "Даход",
 "Выдаткі",
 "Папаўненне",
 "Зняцце"
      ],
      state: [
          "Усе",
        'Папаўненне', //1 перазарадка
        'Зняцце', //2 зняцце
        'Апублікаваць заданне', // 3 заданне
        'Плат помпа', //4 помпа
        'Зніжка', //5 скідка
        "Місія выканана", //6 камісія
        "Узнагароды за актыўнасць", // 7 рэгмент
        'Узнагароды за рэкамендацыі', //8 спрэд
        'Абнаўленне', //9 buymembers
        'Скасаваць заданне', //10 адклікаць
        "Інвестыцыйны даход", //11 transfer_c
        'Пераход у інвестыцыі', //12 transfer_r
        "Іншыя даходы", // 13 其他
        'Дабрачынныя ахвяраванні', //14
        'Чырвоны канверт', //15
        "Купляйце разумных робатаў", //16
        "Шчаслівы розыгрыш", //17
        "Вяртанне грошай за пакупку", //18
      ]
    },
    promote: [
        "Твой лепшы сябар",
        "Запрашаем вас далучыцца да {title}",
        "Рэферальны код",
        "Капіяваць код рэкамендацыі",
        "Скапіраваць спасылку на запрашэнне",
        "Захаваць QR-код",
        "Рэкламныя заахвочванні",
        "Захаваць плакат паспяхова", //7
        "Не ўдалося захаваць плакат, паспрабуйце яшчэ некалькі разоў або захавайце скрыншот",
        "Калі ласка, скрыншот",
        "Захаваць рэкламны плакат",
        "Захавайце рэкламны плакат на свой тэлефон<br>Калі ў вас не атрымалася, паспрабуйце яшчэ некалькі разоў або захавайце скрыншот",
        "Толькі калі вы станеце афіцыйным супрацоўнікам ўзроўню Т, вы маеце права запрашаць сяброў далучыцца!",
        "Запрасіць",
        "<p>1. Бонус за рэкамендацыю: прыцягненне новых удзельнікаў да SGM.s атрымае бонус за рэкамендацыю.</p><p>2. Камісія каманды: Вы можаце атрымліваць камісію з заданняў падпарадкаваных членаў кожны дзень.</p><p>3. Дзейнасць кампаніі: час ад часу кампанія запускае розныя мерапрыемствы сацыяльнага забеспячэння, у тым ліку розыгрышы шчасліўчыкаў, грашовыя чырвоныя канверты, фізічныя прызы і іншыя мерапрыемствы і перавагі.</p><p>4. Сукупны бонус: калі агульная колькасць запрошаных сяброў дасягне пэўнай колькасці, вы можаце атрымаць прызначаную грашовую ўзнагароду на галоўнай старонцы платформы. Чым больш назапашана, тым вышэй бонус.</p><p>5. Пасада ў кампаніі: Калі ваша каманда развіваецца да пэўнага маштабу, вы можаце далучыцца да большай колькасці пазіцый у кампаніі, такіх як пасады малодшага/сярэдняга/старэйшага звяна/памочніка кіраўніка, і вы можаце атрымліваць дадатковую зарплату кожны месяц. У SGM мы забяспечваем шырокую прастору для развіцця для ўсіх супрацоўнікаў. Ва ўсіх роўныя магчымасці. Давайце разам станем сведкамі поспеху кожнага ўдзельніка!</p>",
        "Развіццё каманды"
    ],
    teamReport: {
      default: [
        "Пошук",
        "Баланс каманды",
        "Перавагі каманды",
        "Папаўненне каманды",
        "Вывад каманды",
        "Нумар першай зарадкі",
        "Нумар першага націску",
        "Памер каманды",
        "Новая каманда",
        "PCE",
        "Я",
        "Карыстальнік",
        "Папаўненне",
        "Зняцце",
        "Зніжка",
        "Камісія",
        "Выбраць дату",
        "Даных няма",
        "Сума зняцця",
        "Нумар зняцця сродкаў",
        "Зніжка пры зняцці сродкаў",
        "Колькасць выбыцця каманд", //21
        "Колькасць партнёраў",
        "Рэкамендаваны агульны даход",
        "Агульны даход ад скідак за выкананне заданняў",
        "Узровень 3 Агульная сума зняцця сродкаў каманды",
        "Ацэнка",
        "Бацька",
        "Запрошаныя",
        "Спіс удзельнікаў",
        "Усяго членаў",
        "Націсніце, каб праглядзець каманду"
      ],
      tabs: [
        "Камандныя справаздачы",
        "Мая каманда"
      ],
      team: [
        "Узровень 1",
        "Узровень 2",
        "Узровень 3"
      ],
      totalUser: "Усяго членаў",
      clickViewTeam: "Націсніце, каб праглядзець каманду"
    },
    help: [
        "Дапаможнік",
        "Недаступна"
    ],
    message:[
       "Праглядзець паведамленне",
        "Няма паведамлення"
    ],
    credit: [
        "Крэдытны рэйтынг",
        "Крэдыт-нота",
        "Крэдытныя запісы",
        "<p>Пачатковая адзнака складае 60 балаў.</p><p>1: Калі адзнака менш за 50 балаў, колькасць выкананых штодзённых заданняў будзе скарачацца ўдвая.</p><p>2: Калі адзнака менш за 30 балаў, штодзённыя працоўныя заданні не могуць быць выкананы.</p><p>3: Калі адзнака менш за 10 балаў, вы не можаце падаць заяўку на зняцце наяўных.</p><p>Правілы ўзнагароджання баламі: павышэнне якасці працы узровень дадасць 5 балаў, а запрашэнне падначаленых стаць (афіцыйнымі супрацоўнікамі) дадасць 1 бал.</p><p>Негатыўнае стаўленне да працы, несвоечасовае выкананне заданняў і парушэнне правілаў кампаніі паўплываюць на ваш асабісты крэдытны бал.</p>",
        "Мая заслуга",
        "Крэдытнай гісторыі пакуль няма"
    ],
    dialog: [
        "Парады",
        "Пацвердзіць",
        "Адпраўка...",
        "Капіраванне выканана паспяхова",
        "Версія сістэмы IOS нізкая і не падтрымліваецца",
        "Ідзе рэгістрацыя...",
        "Загрузка даных..."
    ],
    lineList: [
        "Выбар радка",
        "Бягучы радок",
        "Лінія"
    ],
    serviceCenter: [
        "Абслугоўванне кліентаў",
        "Прывітанне, эксклюзіўнае абслугоўванне кліентаў",
        "Рады служыць вам",
        "Самаабслугоўванне",
        "Анлайн абслугоўванне кліентаў",
        "Папоўніце службу падтрымкі",
        "Лінія абслугоўвання кліентаў"
    ],
    direct:[
        "SGM.s",
        "Бонус росту",
        "Апісанне дзейнасці",
        '<p>Пасля непасрэднага запрашэння ўдзельнікаў далучыцца да ўзроўню LP вы можаце атрымаць грашовыя ўзнагароды, калі вы адпавядаеце ўмовам!</p><p>Напрыклад: калі вы запрашаеце 3 удзельнікаў ўзроўню LP разам, вы можаце атрымаць узнагароду непасрэдна. Атрымаўшы яе, працягвайце дасягаць іншых мэтаў і працягвайце яе атрымліваць.</p><p>Эксклюзіўная ўзнагарода за рост SGM.s, кожная ўзнагарода можа быць атрымана кожным супрацоўнікам толькі адзін раз.</p>',
        "Колькасць падпарадкаваных",
        "Будзе скончана",
        "Перавагі запрашэння",
        "Атрымаць узнагароды",
        "Атрымана"
    ],
    activity:[
      "Дабрачыннасць",
      "Падрабязнасці",
      "Ахвяраваць",
      "Баланс рахунку",
      "Усе",
      "Плаці",
      "Калі ласка, увядзіце суму ахвяравання",
      "Дзякуй за ваша ахвяраванне"
    ],
    apply: {
      awardsTitle: "Awards",
      awardsContent: "Awards",
      pickUpVehicles: "Забраць {count} адзінак тэхнікі"
    },
    positions:{
      info:["Падрабязныя звесткі аб пасадзе", "Заяўка на пасаду", "Пасада", "Звычайныя супрацоўнікі групы G-ўзроўню ўзроўню 3", "Каэфіцыент членаў каманды трэцяга ўзроўню", "Заробак у гэтым месяцы", "Разлік заработнай платы", "Завершана", "Будзе выканана", "Атрымана", "Час атрымання зарплаты"],
      job: [
        "Адправіць на разгляд",
        "На разглядзе",
        "Разгледжаны",
        "Калі ласка, загрузіце адпаведныя дакументы",
        "Каментарыі",
        'Націсніце на малюнак, каб выбраць і загрузіць фота вашага пасведчання асобы. ',
        "Калі ласка, загрузіце фатаграфію пярэдняй часткі вашага пасведчання асобы ў фота A.",
        "Калі ласка, загрузіце фатаграфію адваротнага боку вашай пасведчання асобы ў Фота B.",
        "Калі ласка, загрузіце сваю фатаграфію з пасведчаннем асобы ў фота C.",
        "Фота А",
        "Фота B",
        "Фота C",
        "Калі ласка, абярыце пасаду, на якую вы хочаце павысіцца",
        "Пасада",
        "Асноўная зарплата",
        "Дадатковы бонус",
        "Заўвага для супрацоўнікаў",
        "Я прачытаў і згаджаюся са зместам 《Інструкцый па заяўцы на пасаду》",
        "Адправіць заяўку на пасаду",
        "Калі ласка, абярыце пазіцыю",
        "Калі ласка, абярыце фота A",
        "Калі ласка, абярыце фота B", "Калі ласка, абярыце фота C"
      ]
    },
  }